import React from "react";

export default function ClientEmail({ register, errors }) {
  const fieldName = "clientemail";

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) || "Invalid email";
  };

  return (
    <div>
      <label className="wdc-field-label" htmlFor={fieldName}>
        Email address
      </label>
      <input
        id={fieldName}
        type="email"
        className="wdc-field"
        placeholder="you@company.com"
        {...register(fieldName, {
          required: "This field is required",
          validate: validateEmail,
        })}
      />
      {errors[fieldName] && (
        <span className="wdc-error">{errors[fieldName].message}</span>
      )}
    </div>
  );
}
